<template>
  <section class="director-app">
    <div class="director-app__padding">
      <div class="director-app__stage">
        <section class="page-area">


          <!-- Intro -->
          <div class="page page--0" v-if="currentPage === 0">

            <p class="page__title">The Director is responsible for achieving the creative, visual and auditory effect of
              a production. The director must determine the budget for the <em>Kids Work!</em> ETV Festival.</p>

            <div class="page__animation_box">

              <!-- qwerty -->
              <div id="start" @click="begin()">
                <p>Click To Begin</p>
              </div>
              <div id="off"></div>
              <div id="on"></div>
              <div id="tv"></div>
              <div id="tv_flash"></div>

              <div id="tv_people1"></div>
              <div id="tv_doll"></div>
              <!-- <div class="eyes"></div> -->
              <div id="mouth"></div>
              <div id="tv_people2"></div>
              <div id="tv_number">
                <p>Call 1-800-555-1234</p>
              </div>
            </div>
          </div>

          <!-- Equipment Cost Instructions -->
          <div class="page page--1" v-if="currentPage === 1">
            <div class="page__instructions">
              <p>Type your name in the Director's box. Click the word equipment to calculate the equipment costs.</p>
            </div>

            <div class="page__background">
              <div class="page__background--heading">
                <p> Kids Work! ETV Production Budget</p>
                <p>X</p>
              </div>

              <div class="page__button_area"></div>

              <div class="flexbox">
                <div class="page__description">
                  <div class="page__description__heading">
                    <p>Project Description</p>
                  </div>

                  <div class="page__description__content">
                    <p>This program will be a live, two-hour studio production in Studio A to help raise money for
                      children's programming on <em>Kids Work!</em> ETV. The set will be pulled from storage. Music for
                      the show will be used from the music library. The crew will work various hours to prepare the
                      studio for the show and to strike the set when the production is over.</p>
                  </div>
                </div>

                <div class="flex_column">
                  <div class="page__project">
                    <div class="page__project__content">
                      <p>Project: Kids Work! ETV Festival</p>
                      <div class="page__project__content--director_box">
                        <label> Director:</label>
                        <input type="text" name="username2" id="username2" autocomplete="off" v-model="username">
                      </div>
                    </div>
                  </div>

                  <div class="page__summary">
                    <div class="page__summary__content">
                      <p>Budget Summary</p>

                      <table class="page__summary__content--table">
                        <tr>
                          <td v-show="currentPage > 0 && currentPage !== 9" @click="equipment_cost(); nextPage();">
                            <label><span>Equipment:</span></label></td>

                          <td><input type='text' id='f_name' name='f_name' /></td>
                        </tr>

                        <tr>
                          <td><label>Personnel:</label></td>
                          <td><input type='text' id='f_name' name='f_name' /></td>
                        </tr>

                        <tr>
                          <td><label>Miscellaneous:</label></td>
                          <td><input type='text' id='f_name' name='f_name' /></td>
                        </tr>

                        <tr>
                          <td><label>GRAND TOTAL:</label></td>
                          <td><input type='text' id='f_name' name='f_name' /></td>
                        </tr>
                      </table>
                    </div>

                    <div class="page__description__content">

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Solve for Equipment Cost -->
          <div class="page page--2" v-show="currentPage === 2">
            <div class="page__instructions">
              <p>Use the equipment cost section of the spreadsheet to solve the following problem. Click SAVE to check
                your answer.</p>
            </div>
            <div class="page__background">
              <div class="page__background--heading">
                <p> Kids Work! ETV Production Budget</p>
                <p>X</p>

                <div id="save2">
                  <div id="save2__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>
                  <div id="save2__content">
                    <div id="save2__content--incorrect">
                      <p class="alert">try again!</p>
                      <p>Your calculation is not correct.</p>
                      <p>Close this window and try again!</p>
                    </div>

                    <div id="save2__content--correct">
                      <p class="alert">Great Job!</p>
                      <p>The cost of each camera is $170.</p>
                      <p>Close this window and click NEXT.</p>
                    </div>

                    <div id="save2__content--close" @click="close('save2')">
                      <p> close X </p>
                    </div>
                  </div>
                </div>

                <div id="help2">
                  <div id="help2__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>

                  <div id="help2__content--unit">
                    <p>unit cost</p>
                    <input type="text" maxlength="1" id="help_number" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number2" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number3" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                  </div>

                  <div id="help2__content--count">
                    <p>count<span>X</span></p>
                    <input type="text" maxlength="1" id="help_number4" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                  </div>

                  <div class="bar"></div>

                  <div id="help2__content--total">
                    <p>total</p>
                    <input type="text" maxlength="1" id="help_number5" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number6" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number7" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                  </div>

                  <div id="help2__content--close" @click="close('help2')">
                    <p> close X </p>
                  </div>

                </div>

                <div id="next2">
                  <div id="next2__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>

                  <div id="next2__content">
                    <div id="next2__content--incorrect">
                      <p class="alert">try again!</p>
                      <p>Your calculation is not correct.</p>
                      <p>Close this window and try again!</p>
                    </div>

                    <div id="next2__content--close" @click="close('next2')">
                      <p> close X </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__button_area">
                <div class="page--button_box">
                  <div class="page__button_area--save" @click="open('save2'), save2()">
                    <div class="save"></div>
                    <p>save</p>
                  </div>

                  <div class="page__button_area--help" @click="open('help2')">
                    <div class="help"></div>
                    <p>help</p>
                  </div>

                  <div class="page__button_area--next" @click="open('next2'), next2()">
                    <div class="next"></div>
                    <p>next</p>
                  </div>
                </div>
              </div>

              <div class="page__content_area">
                <div class="page__content_area--question">
                  <p> Three cameras were used to film the production. What is the cost of each camera in Studio A?</p>
                </div>
                <div class="page__content_area--table">
                  <table class="page2">
                    <tr>
                      <th colspan="2">A</th>
                      <th>B</th>
                      <th>C</th>
                      <th>D</th>
                      <th>E</th>
                    </tr>

                    <tr class="sub_heading">
                      <td style="color:black;">1</td>
                      <td>Equipment</td>
                      <td>Unit Cost</td>
                      <td>Count</td>
                      <td></td>
                      <td>Total</td>
                    </tr>

                    <tr>
                      <td>2</td>
                      <td>Camera</td>
                      <td class="scene_input"><label>$</label><input type="text" id="camera_cost" autocomplete="off"
                          oninput="this.value=this.value.replace(/[^0-9]/g,'');"></td>
                      <td>3</td>
                      <td></td>
                      <td>$510</td>
                    </tr>

                    <tr>
                      <td>3</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>4</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>5</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr class="last_row">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                  </table>
                </div>
              </div>
              <div class="page__total_cost">
                <p>Total Equipment Cost:</p>
                <p class="cash">$</p>
                <div class="page__total_cost--total_box">
                  <p>510</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Miscellaneous Cost Instructions -->
          <div class="page page--3" v-show="currentPage === 3">
            <div class="page__instructions">
              <p>Notice your equipment costs have been added to the budget summary box. Click the word miscellaneous to
                calculate the miscellaneous costs.</p>
            </div>
            <div class="page__background">
              <div class="page__background--heading">
                <p> Kids Work! ETV Production Budget</p>
                <p>X</p>
              </div>

              <div class="page__button_area"></div>

              <div class="flexbox">
                <div class="page__description">
                  <div class="page__description__heading">
                    <p>Project Description</p>
                  </div>

                  <div class="page__description__content">
                    <p>This program will be a live, two-hour studio production in Studio A to help raise money for
                      children's programming on <em>Kids Work!</em> ETV. The set will be pulled from storage. Music for
                      the show will be used from the music library. The crew will work various hours to prepare the
                      studio for the show and to strike the set when the production is over.</p>
                  </div>
                </div>

                <div class="flex_column">
                  <div class="page__project">
                    <div class="page__project__content">
                      <p>Project: Kids Work! ETV Festival</p>
                      <div class="page__project__content--director_box">
                        <label> Director:</label>
                        <input type="text" name="username2" id="username2" autocomplete="off" v-model="username">
                      </div>
                    </div>
                  </div>

                  <div class="page__summary">
                    <div class="page__summary__content">
                      <p>Budget Summary</p>

                      <table class="page__summary__content--table">
                        <tr>
                          <td><label>Equipment:</label></td>
                          <td>
                            <p>$510</p>
                          </td>
                        </tr>

                        <tr>
                          <td><label>Personnel:</label></td>
                          <td><input type='text' id='f_name' name='f_name' /></td>
                        </tr>

                        <tr>
                          <td v-show="currentPage > 0 && currentPage !== 9" @click="misc_cost(); nextPage();">
                            <label><span>Miscellaneous:</span></label></td>

                          <td><input type='text' id='f_name' name='f_name' /></td>
                        </tr>

                        <tr>
                          <td><label>GRAND TOTAL:</label></td>
                          <td><input type='text' id='f_name' name='f_name' /></td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Solve for Miscellaneous Cost -->
          <div class="page page--4" v-show="currentPage === 4">
            <div class="page__instructions">
              <p>Use the miscellaneous cost section of the spreadsheet to solve the following problem. Fill in the NEW
                total miscellaneous cost and click SAVE.</p>
            </div>
            <div class="page__background">
              <div class="page__background--heading">
                <p> Kids Work! ETV Production Budget</p>
                <p>X</p>

                <div id="save4">
                  <div id="save4__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>
                  <div id="save4__content">
                    <div id="save4__content--incorrect">
                      <p class="alert">try again!</p>
                      <p>Your calculation is not correct.<br>
                        Check ALL of your answers.</p>
                      <p>Close this window and try again!</p>
                    </div>

                    <div id="save4__content--correct">
                      <p class="alert">Great Job!</p>
                      <p>The total miscellaneous cost is $425.</p>
                      <p>Close this window and click NEXT.</p>
                    </div>

                    <div id="save4__content--close" @click="close('save4')">
                      <p> close X </p>
                    </div>
                  </div>
                </div>

                <div id="help4">
                  <div id="help4__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>

                  <div id="help4__content--stock">
                    <p>stock set materials</p>
                    <input type="text" maxlength="1" id="help_number8" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number9" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number10" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                  </div>

                  <div id="help4__content--music">
                    <p>music for production</p>
                    <input type="text" maxlength="1" id="help_number11" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number12" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number13" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                  </div>

                  <div id="help4__content--dinner">
                    <p>dinner for cast/crew</p>
                    <div class="group">
                      <input type="text" maxlength="1" id="help_number14" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                      <input type="text" maxlength="1" id="help_number15" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    </div>
                  </div>

                  <div id="help4__content--talent">
                    <p>celebrity talent<span>+</span></p>
                    <div class="group">
                      <input type="text" maxlength="1" id="help_number16" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                      <input type="text" maxlength="1" id="help_number17" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    </div>
                  </div>

                  <div class="bar"></div>

                  <div id="help4__content--total">
                    <p>total</p>
                    <input type="text" maxlength="1" id="help_number18" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number19" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    <input type="text" maxlength="1" id="help_number20" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                  </div>

                  <div id="help4__content--close" @click="close('help4')">
                    <p> close X </p>
                  </div>

                </div>

                <div id="next4">
                  <div id="next4__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>

                  <div id="next4__content">
                    <div id="next4__content--incorrect">
                      <p class="alert">try again!</p>
                      <p>Your calculation is not correct.<br>Check ALL of your answers.</p>
                      <p>Close this window and try again!</p>
                    </div>

                    <div id="next4__content--close" @click="close('next4')">
                      <p> close X </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__button_area">
                <div class="page--button_box">
                  <div class="page__button_area--save" @click="open('save4'), save4()">
                    <div class="save"></div>
                    <p>save</p>
                  </div>

                  <div class="page__button_area--help" @click="open('help4')">
                    <div class="help"></div>
                    <p>help</p>
                  </div>

                  <div class="page__button_area--next" @click="open('next4'), next4()">
                    <div class="next"></div>
                    <p>next</p>
                  </div>
                </div>
              </div>

              <div class="page__content_area">
                <div class="page__content_area--question">
                  <p> The producer spent $150 on stock set materials and $125 on music. The price of celebrity talent is
                    $200 less than the total cost of stock set materials and music. What is the price of celebrity
                    talent?</p>
                </div>
                <div class="page__content_area--table">
                  <table class="page4">
                    <tr>
                      <th colspan="2">A</th>
                      <th>B</th>
                      <th>C</th>
                      <th>D</th>
                      <th>E</th>
                    </tr>

                    <tr class="sub_heading">
                      <td style="color:black;">1</td>
                      <td>Miscellaneous</td>
                      <td>Unit Cost</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>2</td>
                      <td>Stock Set Materials</td>
                      <td>$150</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>3</td>
                      <td>Music for Production</td>
                      <td>$125</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>4</td>
                      <td>Dinner for cast/crew</td>
                      <td>$75</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>5</td>
                      <td>Celebrity Talent</td>
                      <td class="scene_input"><label>$</label><input type="text" id="talent" autocomplete="off"
                          oninput="this.value=this.value.replace(/[^0-9]/g,'');"></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr class="last_row">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                  </table>
                </div>
              </div>
              <div class="page__total_cost">
                <p>Total Miscellaneous Cost:</p>
                <p class="cash">$</p>
                <div class="page__total_cost--total_box">
                  <input type="text" id="misc_cost" autocomplete="off"
                    oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                </div>
              </div>
            </div>
          </div>

          <!--Personnel Cost Instructions -->
          <div class="page page--5" v-show="currentPage === 5">
            <div class="page__instructions">
              <p>Notice your miscellaneous costs have been added to the budget summary box. Click the word personnel to
                calculate the personnel costs.</p>
            </div>
            <div class="page__background">
              <div class="page__background--heading">
                <p> Kids Work! ETV Production Budget</p>
                <p>X</p>
              </div>

              <div class="page__button_area"></div>

              <div class="flexbox">
                <div class="page__description">
                  <div class="page__description__heading">
                    <p>Project Description</p>
                  </div>

                  <div class="page__description__content">
                    <p>This program will be a live, two-hour studio production in Studio A to help raise money for
                      children's programming on <em>Kids Work!</em> ETV. The set will be pulled from storage. Music for
                      the show will be used from the music library. The crew will work various hours to prepare the
                      studio for the show and to strike the set when the production is over.</p>
                  </div>
                </div>

                <div class="flex_column">
                  <div class="page__project">
                    <div class="page__project__content">
                      <p>Project: Kids Work! ETV Festival</p>
                      <div class="page__project__content--director_box">
                        <label> Director:</label>
                        <input type="text" name="username3" id="username3" autocomplete="off" v-model="username">
                      </div>
                    </div>
                  </div>

                  <div class="page__summary">
                    <div class="page__summary__content">
                      <p>Budget Summary</p>

                      <table class="page__summary__content--table">
                        <tr>
                          <td><label>Equipment:</label></td>
                          <td>
                            <p>$510</p>
                          </td>
                        </tr>

                        <tr>
                          <td v-show="currentPage > 0 && currentPage !== 9" @click="pers_cost(); nextPage();">
                            <label><span>Personnel:</span></label></td>

                          <td><input type='text' id='f_name' name='f_name' /></td>
                        </tr>

                        <tr>
                          <td><label>Miscellaneous:</label></td>
                          <td>
                            <p>$425</p>
                          </td>
                        </tr>

                        <tr>
                          <td><label>GRAND TOTAL:</label></td>
                          <td><input type='text' id='f_name' name='f_name' /></td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Solve for Personnel Cost -->
          <div class="page page--6" v-show="currentPage === 6">
            <div class="page__instructions">
              <p>Calculate and fill in the missing numbers. Add up the totals and fill in the NEW total personnel cost.
                Click SAVE to check your answers.</p>
            </div>
            <div class="page__background">
              <div class="page__background--heading">
                <p> Kids Work! ETV Production Budget</p>
                <p>X</p>

                <div id="save6">
                  <div id="save6__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>
                  <div id="save6__content">
                    <div id="save6__content--incorrect">
                      <p class="alert">try again!</p>
                      <p>The total personnel cost is incorect!<br>
                        Check ALL of your answers.</p>
                      <p>Close this window and try again!</p>
                    </div>

                    <div id="save6__content--correct">
                      <p class="alert">Great Job!</p>
                      <p>The total personnel cost is $1526.</p>
                      <p>Close this window and click NEXT.</p>
                    </div>

                    <div id="save6__content--close" @click="close('save6')">
                      <p> close X </p>
                    </div>
                  </div>
                </div>

                <div id="help6">
                  <div id="help6__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>

                  <div id="help6__content--cost">
                    <p>cost/hr</p>
                    <div class="group">
                      <input type="text" maxlength="1" id="help_number21" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                      <input type="text" maxlength="1" id="help_number22" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    </div>
                  </div>

                  <div id="help6__content--count">
                    <p>count<span>x</span></p>
                    <input type="text" maxlength="1" id="help_number23" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                  </div>

                  <div class="bar"></div>

                  <div id="help6__content--cost">
                    <p></p>
                    <div class="group">
                      <input type="text" maxlength="1" id="help_number24" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                      <input type="text" maxlength="1" id="help_number25" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    </div>
                  </div>

                  <div id="help6__content--hours">
                    <p># of hours<span id="adjust">x</span></p>
                    <input type="text" maxlength="1" id="help_number26" autocomplete="off"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                  </div>

                  <div class="bar"></div>

                  <div id="help6__content--total">
                    <p>total</p>
                    <div class="group">
                      <input type="text" maxlength="1" id="help_number27" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                      <input type="text" maxlength="1" id="help_number28" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                      <input type="text" maxlength="1" id="help_number29" autocomplete="off"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                    </div>
                  </div>

                  <div id="help6__content--close" @click="close('help6')">
                    <p> close X </p>
                  </div>

                </div>

                <div id="next6">
                  <div id="next6__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>

                  <div id="next6__content">
                    <div id="next6__content--incorrect">
                      <p class="alert">try again!</p>
                      <p>The total personnel cost is incorect!<br>
                        Check ALL of your answers.</p>
                      <p>Close this window and try again!</p>
                    </div>

                    <div id="next6__content--close" @click="close('next6')">
                      <p> close X </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__button_area">
                <div class="page--button_box">
                  <div class="page__button_area--save" @click="open('save6'), save6()">
                    <div class="save"></div>
                    <p>save</p>
                  </div>

                  <div class="page__button_area--help" @click="open('help6')">
                    <div class="help"></div>
                    <p>help</p>
                  </div>

                  <div class="page__button_area--next" @click="open('next6'), next6()">
                    <div class="next"></div>
                    <p>next</p>
                  </div>
                </div>
              </div>

              <div class="page__content_area--noBackground">
                <div class="page__content_area--table">
                  <table class="page6">
                    <tr>
                      <th colspan="2">A</th>
                      <th>B</th>
                      <th>C</th>
                      <th>D</th>
                      <th>E</th>
                    </tr>

                    <tr class="sub_heading">
                      <td style="color:black;">1</td>
                      <td>Personnel</td>
                      <td>Cost/hr</td>
                      <td>Count</td>
                      <td># of hours</td>
                      <td>Total</td>
                    </tr>

                    <tr>
                      <td>2</td>
                      <td>Director</td>
                      <td>$24</td>
                      <td>1</td>
                      <td>8</td>
                      <td>$192</td>
                    </tr>

                    <tr>
                      <td>3</td>
                      <td>Technical Director</td>
                      <td>$19</td>
                      <td>1</td>
                      <td>8</td>
                      <td class="scene_input"><label>$</label><input type="text" id="td_total" autocomplete="off"
                          oninput="this.value=this.value.replace(/[^0-9]/g,'');"></td>
                    </tr>

                    <tr>
                      <td>4</td>
                      <td>Producer</td>
                      <td>$23</td>
                      <td>1</td>
                      <td class="scene_input"><input type="text" id="p_hours" autocomplete="off"
                          oninput="this.value=this.value.replace(/[^0-9]/g,'');"></td>
                      <td>$230</td>
                    </tr>

                    <tr>
                      <td>5</td>
                      <td>Lighting Director</td>
                      <td>$21</td>
                      <td>1</td>
                      <td>8</td>
                      <td>$168</td>
                    </tr>

                    <tr>
                      <td>6</td>
                      <td>Floor Manager</td>
                      <td class="scene_input"><label>$</label><input type="text" id="fm_cost" autocomplete="off"
                          oninput="this.value=this.value.replace(/[^0-9]/g,'');"></td>
                      <td>1</td>
                      <td>5</td>
                      <td>$100</td>
                    </tr>

                    <tr>
                      <td>7</td>
                      <td>Scenic Designer</td>
                      <td>$19</td>
                      <td>1</td>
                      <td>6</td>
                      <td class="scene_input"><label>$</label><input type="text" id="sd_total" autocomplete="off"
                          oninput="this.value=this.value.replace(/[^0-9]/g,'');"></td>
                    </tr>

                    <tr>
                      <td>8</td>
                      <td>Audio/Video Tech</td>
                      <td>$18</td>
                      <td>1</td>
                      <td>8</td>
                      <td>$144</td>
                    </tr>

                    <tr>
                      <td>9</td>
                      <td>Camera Operator</td>
                      <td>$17</td>
                      <td class="scene_input"><input type="text" id="co_count" autocomplete="off"
                          oninput="this.value=this.value.replace(/[^0-9]/g,'');"></td>
                      <td>6</td>
                      <td>$306</td>
                    </tr>

                    <tr>
                      <td>10</td>
                      <td>Record Technician</td>
                      <td>$15</td>
                      <td>1</td>
                      <td>8</td>
                      <td>$120</td>
                    </tr>

                    <tr class="last_row">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                  </table>
                </div>
              </div>
              <div class="page__total_cost">
                <p>Total Personnel Cost:</p>
                <p class="cash">$</p>
                <div class="page__total_cost--total_box">
                  <input type="text" id="pers_cost" autocomplete="off"
                    oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                </div>
              </div>
            </div>
          </div>

          <!-- Calc Grand Total -->
          <div class="page page--7" v-if="currentPage === 7">
            <div class="page__instructions">
              <p>Add up the totals and fill in the grand total. Click SAVE when you are finished.</p>
            </div>
            <div class="page__background">
              <div class="page__background--heading">
                <p> Kids Work! ETV Production Budget</p>
                <p>X</p>

                <div id="save7">
                  <div id="save7__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>
                  <div id="save7__content">
                    <div id="save7__content--incorrect">
                      <p class="alert">try again!</p>
                      <p>Your calculation is not correct.</p>
                      <p>Close this window and try again!</p>
                    </div>

                    <div id="save7__content--correct">
                      <p class="alert">Great Job!</p>
                      <p>The TOTAL budget for the Kids Works!</p>
                      <p>ETV Festival production is $2461.</p>
                    </div>

                    <div id="save7__content--close" @click="close('save7')">
                      <p> close X </p>
                    </div>
                  </div>
                </div>

                <div id="next7">
                  <div id="next7__heading">
                    <p>Scratch Pad (HINT)</p>
                  </div>

                  <div id="next7__content">
                    <div id="next7__content--incorrect">
                      <p class="alert">try again!</p>
                      <p>Your calculation is not correct.</p>
                      <p>Close this window and try again!</p>
                    </div>

                    <div id="next7__content--close" @click="close('next7')">
                      <p> close X </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__button_area">
                <div class="page--button_box">
                  <div class="page__button_area--save" @click="open('save7'), save7()">
                    <div class="save"></div>
                    <p>save</p>
                  </div>

                  <div class="page__button_area--next" @click="open('next7'), next7()">
                    <div class="next"></div>
                    <p>exit</p>
                  </div>
                </div>
              </div>

              <div class="flexbox">
                <div class="page__description">
                  <div class="page__description__heading">
                    <p>Project Description</p>
                  </div>

                  <div class="page__description__content">
                    <p>This program will be a live, two-hour studio production in Studio A to help raise money for
                      children's programming on <em>Kids Work!</em> ETV. The set will be pulled from storage. Music for
                      the show will be used from the music library. The crew will work various hours to prepare the
                      studio for the show and to strike the set when the production is over.</p>
                  </div>
                </div>

                <div class="flex_column">
                  <div class="page__project">
                    <div class="page__project__content">
                      <p>Project: Kids Work! ETV Festival</p>
                      <div class="page__project__content--director_box">
                        <label> Director:</label>
                        <input type="text" name="username4" id="username4" autocomplete="off" v-model="username">
                      </div>
                    </div>
                  </div>

                  <div class="page__summary">
                    <div class="page__summary__content">
                      <p>Budget Summary</p>

                      <table class="page__summary__content--table">
                        <tr>
                          <td><label>Equipment:</label></td>
                          <td>
                            <p>$510</p>
                          </td>
                        </tr>

                        <tr>
                          <td><label>Personnel:</label></td>
                          <td>
                            <p>$1526</p>
                          </td>
                        </tr>

                        <tr>
                          <td><label>Miscellaneous:</label></td>
                          <td>
                            <p>$425</p>
                          </td>
                        </tr>

                        <tr>
                          <td v-show="currentPage > 0 && currentPage !== 9">
                            <label class="total"><span>Grand Total:</span></label></td>

                          <td><input type="text" id="grand_total" autocomplete="off"
                              oninput="this.value=this.value.replace(/[^0-9]/g,'');"></td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Navagation -->
          <!-- <div class="director-app__nav">
            <button v-show="currentPage > 0 && currentPage !== 9" @click="prevPage"
              class="i-btn i-btn--back">Back</button>
            <button v-if="currentPage < 9" @click="nextPage" class="i-btn i-btn--next">Next</button>
          </div> -->
        </section>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    Howl
  } from 'howler';


  export default {
    name: 'app',
    components: {},
    data: function () {
      return {
        username: '',
        isDragging: false,
        hasToolBeenUsed: false,
        currentPage: 0,
        currentSoundId: null,
        audio: new Howl({
          src: ['audio/director-audio.mp3'],
          sprite: {
            director: [0, 28000],
            equipment_cost: [29000, 7000],
            equipment_cost_added: [37000, 11000],
            notice_ec: [45300, 9000],
            misc_cost: [54274, 9114],
            notice_mc: [63520, 8742],
            pers_cost: [72262, 9067],
            grand_total: [81465, 5248],
            try_again: [86720, 1019],
            great_job: [87739, 969],
          },
        }),
      }
    },

    created() {
      
    },

    mounted() {},


    methods: {
      activate() {
        if (this.currentPage === 0) {
          setTimeout(() => this.currentPage++, 22000);
        }
      },
      nextPage() {
        if (this.currentPage < 7) {
          this.currentPage++;
        }
      },
      prevPage() {
        if (this.currentPage > 0) {
          this.currentPage--;
        }
      },
      equipment_cost() {
        this.audio.stop();
        this.audio.play('equipment_cost');
      },
      equipment_cost_added() {
        this.audio.stop();
        this.audio.play('equipment_cost_added');
      },
      notice_ec() {
        this.audio.stop();
        this.audio.play('notice_ec');
      },
      misc_cost() {
        this.audio.stop();
        this.audio.play('misc_cost');
      },
      notice_mc() {
        this.audio.stop();
        this.audio.play('notice_mc');
      },
      pers_cost() {
        this.audio.stop();
        this.audio.play('pers_cost');
      },
      grand_total() {
        this.audio.stop();
        this.audio.play('grand_total');
      },
      try_again() {
        this.audio.play('try_again');
      },
      great_job() {
        this.audio.play('great_job');
      },

      open(saveId) {
        var x = document.getElementById(saveId);

        if (x.style.display === "block") {
          x.style.display = "none";
        } else {
          x.style.display = "block";
        }
      },

      // qwerty
      begin() {

        if (this.currentPage === 0) {

            this.audio.play('director');
            this.activate();
            // https://stackoverflow.com/questions/4847996/css-animation-onclick
            document.getElementById("off").style.WebkitAnimationPlayState = "running";
            document.getElementById("on").style.WebkitAnimationPlayState = "running";
            document.getElementById("tv").style.WebkitAnimationPlayState = "running";
            document.getElementById("tv_flash").style.WebkitAnimationPlayState = "running";
            document.getElementById("tv_people1").style.WebkitAnimationPlayState = "running";
            document.getElementById("tv_doll").style.WebkitAnimationPlayState = "running";
            document.getElementById("mouth").style.WebkitAnimationPlayState = "running";
            document.getElementById("tv_people2").style.WebkitAnimationPlayState = "running";
            document.getElementById("tv_number").style.WebkitAnimationPlayState = "running";
            document.getElementById("start").style.zIndex = 0;
          } else {
            // console.log(x);
          }
      },

      close(saveId) {
        var x = document.getElementById(saveId);

        if (x !== null) {
          if (x.style.display === "none") {
            x.style.display = "block";
          } else {
            x.style.display = "none";
          }
        }
      },

      // save(saveId) {
      //   //sd sdf

      //   if (saveId === 'save2') {
      //     //sdfsdfs
      //   }

      //   if (saveId === 'save4') {
      //     this.save2calc('something');
      //   }
      // },
      save2calc(sumptin) {
        console.log(sumptin)
      },

      save2() {

        var a = document.getElementById("camera_cost").value;
        if (a == 170) {
          this.great_job();
          document.getElementById("save2__content--correct").style.display = 'block';
          document.getElementById("save2__content--incorrect").style.display = 'none';
        } else {
          this.try_again();
          document.getElementById("save2__content--incorrect").style.display = 'block';
          document.getElementById("save2__content--correct").style.display = 'none';
        }
      },

      save4() {

        var a = document.getElementById("talent").value;
        var b = document.getElementById("misc_cost").value;

        if (a == 75 && b == 425) {
          this.great_job();
          document.getElementById("save4__content--correct").style.display = 'block';
          document.getElementById("save4__content--incorrect").style.display = 'none';
        } else {
          this.try_again();
          document.getElementById("save4__content--incorrect").style.display = 'block';
          document.getElementById("save4__content--correct").style.display = 'none';
        }
      },

      save6() {

        var a = document.getElementById("fm_cost").value;
        var b = document.getElementById("co_count").value;
        var c = document.getElementById("p_hours").value;
        var d = document.getElementById("td_total").value;
        var e = document.getElementById("sd_total").value;
        var f = document.getElementById("pers_cost").value;

        if (a == 20 && b == 3 && c == 10 && d == 152 && e == 114 && f == 1526) {
          this.great_job();
          document.getElementById("save6__content--correct").style.display = 'block';
          document.getElementById("save6__content--incorrect").style.display = 'none';
        } else {
          this.try_again();
          document.getElementById("save6__content--incorrect").style.display = 'block';
          document.getElementById("save6__content--correct").style.display = 'none';
        }
      },

      save7() {

        var a = document.getElementById("grand_total").value;

        if (a == 2461) {
          this.great_job();
          document.getElementById("save7__content--correct").style.display = 'block';
          document.getElementById("save7__content--incorrect").style.display = 'none';
        } else {
          this.try_again();
          document.getElementById("save7__content--incorrect").style.display = 'block';
          document.getElementById("save7__content--correct").style.display = 'none';
        }
      },

      next2() {

        var a = document.getElementById("camera_cost").value;
        if (a == 170) {
          this.nextPage();
          this.notice_ec();
          document.getElementById("next2").style.display = 'none';
        } else {
          this.try_again()
          document.getElementById("next2__content--incorrect").style.display = 'block';
        }
      },

      next4() {

        var a = document.getElementById("talent").value;
        var b = document.getElementById("misc_cost").value;

        if (a == 75 && b == 425) {
          this.nextPage();
          this.notice_mc();
          document.getElementById("next4").style.display = 'none';
        } else {
          this.try_again()
          document.getElementById("next4__content--incorrect").style.display = 'block';
        }
      },

      next6() {

        var a = document.getElementById("fm_cost").value;
        var b = document.getElementById("co_count").value;
        var c = document.getElementById("p_hours").value;
        var d = document.getElementById("td_total").value;
        var e = document.getElementById("sd_total").value;
        var f = document.getElementById("pers_cost").value;

        if (a == 20 && b == 3 && c == 10 && d == 152 && e == 114 && f == 1526) {
          this.nextPage();
          this.grand_total();
          document.getElementById("next6").style.display = 'none';
        } else {
          this.try_again()
          document.getElementById("next6__content--incorrect").style.display = 'block';
        }
      },

      next7() {

        var a = document.getElementById("grand_total").value;

        if (a == 2461) {
          var url = "https://www.knowitall.org/grades?grade%5B%5D=2&Type%5B%5D=interactive";
          window.location = url;
          document.getElementById("next7").style.display = 'none';
        } else {
          this.try_again()
          document.getElementById("next7__content--incorrect").style.display = 'block';
        }
      },
    }
  }
</script>

<style lang="scss">
  @import "style";

  .hide-tool {
    z-index: -1;
  }

  .smooth-dnd-container {
    .animated {
      transform: none !important;
    }
  }

  .director-app {
    margin: 0;
    padding: 0;

    &__nav {
      position: absolute;
      right: fluid(110px);
      bottom: fluid(10px);
      width: fluid(180px);

      button {
        font-family: $cursive;
        text-transform: uppercase;
        cursor: pointer;
      }
    }

    &__padding {
      position: relative;
      padding: 0 0 #{(380/725)*100%};
    }

    &__stage {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  .page-area {
    width: 100%;
    height: fluid(445px);
    background: $orange;
    position: absolute;
    margin: auto;
  }

  .page {
    &__title {
      font-weight: 300;
      color: #000;
      margin: fluid(10px) auto;
      font-size: fluid(18.5px);
      line-height: 1.2em;
      font-weight: 700;
      width: 90%;
    }

    &__sub_title {
      text-align: center;
      width: 100%;
      text-transform: uppercase;
      color: #000;
      font-size: fluid(12px);
      text-transform: uppercase;
      margin: 0;
      padding: fluid(10px) 0px;
    }

    &__animation_box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: fluid(725px);
      height: fluid(325px);
    }

    &__instructions {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: left;
      width: 100%;
      height: fluid(56px);
      background: #fff;

      p {
        width: 93%;
        font-size: fluid(18px);
        font-weight: 700;
        margin: 0;
        padding: fluid(5px) fluid(0px);
      }
    }

    &__background {
      width: 100%;
      height: fluid(389px);
      background-color: #C5C5C5;
      border: 1px solid #000;

      &--heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: fluid(23px);
        width: 100%;
        background-color: #006600;
        border-bottom: 1px solid #000;

        p {
          color: white;
          font-weight: 700;
          padding: fluid(0px) fluid(8px);
          margin: 0px;
        }
      }
    }

    &--button_box {
      display: flex;
      padding-left: fluid(15px);
    }

    &__button_area {
      display: flex;
      align-items: center;
      height: fluid(40px);
      width: 100%;
      border-bottom: 1px solid #000;
      background-color: #C5C5C5;

      &--save,
      &--help,
      &--next {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: fluid(90px);
        margin: fluid(0px) fluid(5px);
        background: #FF9900;
        border: 1px solid #000;
        @include image;

        p {
          text-transform: uppercase;
          font-weight: 700;
          margin: 0;
          padding: 0;
        }

        &:hover {
          color: #fff;
          background: #666;
        }
      }

      &--save {
        position: relative;

        .save {
          background-image: url('~@/assets/img/save.svg');
          height: fluid(17px);
          width: fluid(17px);
          @include image;
        }
      }

      &--help {
        position: relative;

        .help {
          display: block;
          background-image: url('~@/assets/img/help.svg');
          height: fluid(17px);
          width: fluid(13px);
          @include image;
        }
      }

      &--next {
        .next {
          display: block;
          background-image: url('~@/assets/img/next.svg');
          height: fluid(20px);
          width: fluid(12px);
          @include image;
        }
      }
    }

    &__description {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      margin: fluid(5px) fluid(0px);
      padding: fluid(3px) fluid(10px);
      height: fluid(300px);
      width: fluid(285px);
      background-color: #fff;
      border: 1px solid #000;
      font-weight: 700;
      border: solid 1px #000;

      // &:after {
      //   content: '';
      //   position: absolute;
      //   top: -15px;
      //   left: -15px;
      //   right: -15px;
      //   bottom: -15px;
      //   border: 1px solid #000;
      //   z-index: 1;
      // }



      &__heading {
        text-transform: uppercase;
        width: 100%;
        text-align: center;
      }

      &__content {
        width: 98%;

        p {
          margin: 0;
        }
      }
    }

    &__project {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      margin: fluid(5px) fluid(0px);
      padding: fluid(3px) fluid(10px);
      height: fluid(80px);
      width: fluid(285px);
      background-color: #fff;
      border: 1px solid #000;
      font-weight: 700;

      label {
        color: red;
      }

      &__content {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        width: 98%;
        height: 100%;

        p {
          margin: 0;
        }

        &--director_box {
          display: flex;
          justify-content: flex-start;

          label {
            color: red;
          }

          #message {
            padding-left: fluid(10px);
            color: #000;
          }

          input {
            margin: fluid(2px) fluid(10px);
            border: 1px solid #000;

            &:focus {
              @include inputFocus;
            }
          }
        }
      }
    }

    &__summary {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      margin: fluid(5px) fluid(0px);
      padding: fluid(3px) fluid(10px);
      height: fluid(200px);
      width: fluid(285px);
      background-color: #fff;
      border: 1px solid #000;
      font-weight: 700;

      &__content {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        width: 90%;
        height: 100%;

        p {
          padding-top: fluid(15px);
          text-transform: uppercase;
          text-align: right;
          margin: 0;
        }

        &--table {
          margin-top: fluid(10px);
          height: fluid(125px);

          span {
            color: blue;
            cursor: pointer;
          }

          #grand_total {
            cursor: default;
          }

          table {
            height: fluid(140px);
            width: fluid(100px);
            background: red;
            margin: 0;
          }

          td {
            text-align: left;
            width: 100%;
          }

          input {
            background-color: #FFFFCC;
            border: 0px solid #000;
            width: 100%;
            text-align: right;

            &:focus {
              @include inputFocus;
            }
          }

          .grandTotal {
            background-color: #FFF;
            border: 1px solid #000;
            width: fluid(100px);
            height: fluid(30px);
            text-align: right;
            font-weight: 700;
          }

          .total {
            text-transform: uppercase;
          }

          p {
            padding: 0;
            margin: 0;
          }
        }
      }
    }

    &__content_area {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      margin: fluid(15px) auto;
      padding-top: fluid(20px);
      width: 95%;
      height: fluid(250px);
      background-color: #fff;

      &--noBackground {
        background-color: transparent;

        table {
          background: #fff;
          line-height: 1.3em;
          margin-bottom: fluid(10px);

          input {
            height: 1.3em;

            &:focus {
              @include inputFocus;
            }
          }
        }
      }

      &--question {
        padding: fluid(0px) fluid(25px);
        font-size: fluid(19px);
        width: 100%;
        height: fluid(75px);
        font-weight: 700;
        // background-color: red;
      }

      &--table {
        margin: 0 auto;
        padding: 0;
        font-size: fluid(18px);
        width: 95%;
        font-weight: 700;

        td,
        th {
          border: 1px solid #000;
        }

        td:first-child {
          background: $grey;
        }

        td label {
          color: red;
        }

        input {
          font-weight: 700;
          height: fluid(23px);
          color: red;
          text-align: center;
          border: 0px solid #000;

          &:focus {
            @include inputFocus;
          }
        }
      }
    }

    &__total_cost {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      width: 80%;
      height: fluid(25px);
      margin: 0 auto;

      p {
        font-size: fluid(19px);
        padding-right: fluid(20px);
        font-weight: 700;
        text-transform: uppercase;
        margin: 0;
      }

      .cash {
        padding-right: fluid(3px);
      }

      &--total_box {
        width: fluid(100px);
        background-color: #fff;
        text-align: right;
        color: red;
        font-size: fluid(18px);
        font-weight: 700;
        height: auto;
        border: 1px solid #000;

        input {
          width: 100%;
          height: fluid(29px);
          color: red;
          font-weight: 700;
          text-align: right;
          border: 0px solid #000;
          padding-right: fluid(5px);

          &:focus {
            @include inputFocus;
          }
        }

        p {
          padding-right: fluid(5px);
        }
      }
    }

    .flexbox {
      display: flex;
      justify-content: space-around;
      margin: 0 auto;
      width: 85%;
      z-index: 5;
    }

    .flex_column {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    table {
      font-size: fluid(16px);
      border-collapse: collapse;

      th {
        background-color: #CFCFCF;
        text-align: center;
      }

      .sub_heading {
        color: blue;
      }



      td {
        padding: 1px;
      }

      tr {
        text-align: center;
      }

      td input {
        width: fluid(100px);
      }

      .last_row {
        background: #CFCFCF;

        td {
          height: fluid(10px);
        }
      }

    }
  }

  #help2 {
    position: absolute;
    top: fluid(55px);
    left: fluid(10px);
    width: fluid(250px);
    height: auto;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      margin-top: fluid(10px);
      justify-content: center;

      &--unit,
      &--count,
      &--total {
        display: flex;
        margin: fluid(10px) auto fluid(0px);
        justify-content: center;
        align-items: flex-end;
        justify-content: space-between;
        width: 90%;

        input {
          width: fluid(40px);
          height: fluid(40px);
          border: 1px solid #000;
          font-size: fluid(30px);
          text-align: right;
        }

        p {
          display: block;
          font-size: fluid(14px);
          width: fluid(80px);
          color: #000;
          ;

          span {
            color: red;
            margin-left: fluid(27px);
          }
        }
      }

      &--close {
        display: flex;
        justify-content: flex-end;
        // justify-content: center;
        width: 100%;

        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(20px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  #help4 {
    position: absolute;
    top: fluid(55px);
    left: fluid(10px);
    width: fluid(250px);
    height: auto;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      margin-top: fluid(10px);
      justify-content: center;

      &--stock,
      &--music,
      &--dinner,
      &--talent,
      &--total {
        display: flex;
        margin: fluid(10px) auto fluid(0px);
        justify-content: center;
        align-items: flex-end;
        justify-content: space-between;
        width: 90%;

        input {
          width: fluid(40px);
          height: fluid(40px);
          border: 1px solid #000;
          font-size: fluid(30px);
          text-align: right;
        }

        p {
          display: block;
          font-size: fluid(14px);
          width: fluid(90px);
          color: #000;
          ;

          span {
            color: red;
            margin-left: fluid(27px);
          }
        }

        .group {
          input {
            margin: fluid(0px) fluid(5px);
          }

          input:last-of-type {
            margin: fluid(0px) fluid(0px);
          }
        }
      }

      &--close {
        display: flex;
        justify-content: flex-end;
        // justify-content: center;
        width: 100%;

        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(20px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  #help6 {
    position: absolute;
    top: fluid(55px);
    left: fluid(10px);
    width: fluid(250px);
    height: auto;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      margin-top: fluid(10px);
      justify-content: center;

      &--cost,
      &--count,
      &--hours,
      &--total {
        display: flex;
        margin: fluid(10px) auto fluid(0px);
        justify-content: center;
        align-items: flex-end;
        justify-content: space-between;
        width: 90%;

        input {
          width: fluid(40px);
          height: fluid(40px);
          border: 1px solid #000;
          font-size: fluid(30px);
          text-align: right;
        }

        p {
          display: block;
          font-size: fluid(14px);
          width: auto;
          color: #000;
          // background: red;

          span {
            color: red;
            margin-left: fluid(35px);
          }

          #adjust {
            margin-left: fluid(5px);
          }
        }

        .group {
          input {
            margin-right: fluid(5px);
          }

          input:last-of-type {
            margin: fluid(0px) fluid(0px);
          }
        }
      }

      &--close {
        display: flex;
        justify-content: flex-end;
        // justify-content: center;
        width: 100%;

        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(20px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(145px);
      height: fluid(1px);
      background: #000;
    }
  }

  #save2 {
    position: absolute;
    top: 25%;
    left: 25%;
    width: fluid(400px);
    height: 60%;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;

      &--correct {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #006600;
          letter-spacing: fluid(4px);
        }
      }

      &--incorrect {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #ff0000;
          letter-spacing: fluid(4px);
        }
      }

      &--close {
        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(0px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  #save4 {
    position: absolute;
    top: 25%;
    left: 25%;
    width: fluid(400px);
    height: 60%;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);

    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;

      &--correct {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #006600;
          letter-spacing: fluid(4px);
        }
      }

      &--incorrect {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #ff0000;
          letter-spacing: fluid(4px);
        }
      }

      &--close {
        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(0px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  #save6 {
    position: absolute;
    top: 25%;
    left: 25%;
    width: fluid(400px);
    height: 60%;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;

      &--correct {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #006600;
          letter-spacing: fluid(4px);
        }
      }

      &--incorrect {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #ff0000;
          letter-spacing: fluid(4px);
        }
      }

      &--close {
        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(0px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  #save7 {
    position: absolute;
    top: 25%;
    left: 25%;
    width: fluid(400px);
    height: 60%;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;

      &--correct {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #006600;
          letter-spacing: fluid(4px);
        }
      }

      &--incorrect {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #ff0000;
          letter-spacing: fluid(4px);
        }
      }

      &--close {
        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(0px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  #next2 {
    position: absolute;
    top: 25%;
    left: 25%;
    width: fluid(400px);
    height: 60%;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;

      &--incorrect {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #ff0000;
          letter-spacing: fluid(4px);
        }
      }

      &--close {
        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(0px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  #next4 {
    position: absolute;
    top: 25%;
    left: 25%;
    width: fluid(400px);
    height: 60%;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;

      &--incorrect {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #ff0000;
          letter-spacing: fluid(4px);
        }
      }

      &--close {
        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(0px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  #next6 {
    position: absolute;
    top: 25%;
    left: 25%;
    width: fluid(400px);
    height: 60%;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;

      &--incorrect {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #ff0000;
          letter-spacing: fluid(4px);
        }
      }

      &--close {
        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(0px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  #next7 {
    position: absolute;
    top: 25%;
    left: 25%;
    width: fluid(400px);
    height: 60%;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 9;
    -webkit-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    -moz-box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    box-shadow: 4px 4px 31px -6px rgba(0, 0, 0, 0.73);
    display: none;

    &__heading {
      height: fluid(15px);
      background-color: #0033CC;

      p {
        color: #fff;
        font-size: fluid(12px);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;

      &--incorrect {
        p {
          text-align: center;
          color: #000;
          font-weight: 200;
          margin-bottom: fluid(15px);
        }

        .alert {
          font-family: $alert;
          text-shadow: 2px 2px 2px #444;
          text-transform: uppercase;
          font-size: fluid(40px);
          margin-bottom: fluid(10px);
          color: #ff0000;
          letter-spacing: fluid(4px);
        }
      }

      &--close {
        p {
          cursor: pointer;
          color: black;
          font-size: fluid(22px);
          border: 1px solid #000;
          margin: fluid(0px) fluid(15px);

          &:hover {
            color: #fff;
            background-color: #000;
          }
        }
      }
    }

    .bar {
      position: absolute;
      right: fluid(0px);
      margin: fluid(5px) fluid(10px);
      width: fluid(155px);
      height: fluid(1px);
      background: #000;
    }
  }

  .i-btn {
    appearance: none;
    border: 0;
    background: transparent;
    font-weight: 600;
    margin: auto;
    font-size: fluid(14px);
    flex: 0 0 auto;

    &:before {
      content: '';
      width: fluid(25px);
      height: fluid(25px);
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      display: block;
      margin: 0 auto;
    }

    &--back {
      float: left;
      justify-self: start;

      &:before {
        background-image: url('~@/assets/img/button_arrow_l.svg');
      }
    }

    &--next {
      float: right;

      &:before {
        background-image: url('~@/assets/img/button_arrow_r.svg');
      }
    }
  }

// qwerty
  #start {
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    width: fluid(150px);
    height: fluid(50px);
    background: #6D00A2;
    border: 4px solid #fff;
    z-index: 99;

    &:hover {
      transition: .5s;
      background: darken(#6D00A2, 10%);
    }

    p {
      font-weight: 700;
      margin: 0;
      padding: 0;
      color: #fff;
    }

  }

  #mouth {
    display: block;
    position: absolute;
    top: fluid(180px);
    left: fluid(219px);
    width: fluid(70px);
    height: fluid(70px);
    background-image: url('~@/assets/img/mouth_2.gif');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 0 auto;
    animation-delay: .5s;
    animation-duration: 30.35s;
    animation-name: mouth;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    z-index: 3;
    opacity: 0;
  }

  @keyframes mouth {
    0% {
      opacity: 0;
    }

    4.9% {
      opacity: 0;
    }

    5% {
      opacity: 1;
    }

    // 49.8% {
    //   opacity: 0;
    // }

    // 49.9% {
    //   opacity: 1;
    // }


    // 53.9% {
    //   opacity: 1;
    // }

    // 54% {
    //   opacity: 0;
    // }

    // 65.4% {
    //   opacity: 0;
    // }

    // 65.6% {
    //   opacity: 1;
    // }

    // 92.9% {
    //   opacity: 1;
    // }

    100% {
      opacity: 1;
    }
  }

  // .eyes {
  //   display: block;
  //     position: absolute;
  //     top: fluid(160px);
  //     left: fluid(223px);
  //     width: fluid(70px);
  //     height: fluid(70px);
  //     background-image: url('~@/assets/img/eyes.svg');
  //     background-repeat: no-repeat;
  //     background-position: center;
  //     background-size: contain;
  //     margin: 0 auto;
  //     animation-duration: 24s;
  //     animation-name: eyes;
  //     animation-iteration-count: 1;
  //     animation-fill-mode: forwards;
  //     z-index: 3;
  //     opacity: 0;
  // }
  //   @keyframes eyes {
  //     0% {
  //       opacity: 0;
  //     }

  //     49.9% {
  //       opacity: 0;
  //     }

  //     50% {
  //       opacity: 1;
  //     }


  //     53.9% {
  //       opacity: 1;
  //     }

  //     54% {
  //       opacity: 0;
  //     }

  //     65.9% {
  //       opacity: 0;
  //     }

  //     66% {
  //       opacity: 1;
  //     }

  //     92.9% {
  //       opacity: 1;
  //     }

  //     93% {
  //       opacity: 0;
  //     }
  //   }


// qwerty
  #tv {
    display: block;
    position: absolute;
    width: fluid(490px);
    height: fluid(349px);
    background-image: url('~@/assets/img/tv_off.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 0 auto;
    animation-duration: 11.75s;
    animation-name: tv1;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    z-index: 4;
    animation-play-state: paused;
  }

  @keyframes tv1 {
    0% {
      opacity: 1;
    }

    99.9% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  #tv_flash {
    position: absolute;
    width: fluid(490px);
    height: fluid(349px);
    background-image: url('~@/assets/img/tv_flash.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 0 auto;
    animation-delay: 11.5s;
    animation-duration: .15s;
    animation-name: tv2;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    z-index: 3;
    animation-play-state: paused;

  }

  @keyframes tv2 {
    0% {
      opacity: 1;
    }

    99.9% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  #tv_people1 {
    position: absolute;
    width: fluid(490px);
    height: fluid(349px);
    background-image: url('~@/assets/img/tv_people.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 0 auto;
    animation-delay: 12s;
    animation-duration: 1s;
    animation-name: tv_people1;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    z-index: 2;
    animation-play-state: paused;

  }

  @keyframes tv_people1 {
    0% {
      opacity: 1;
    }

    99.9% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  #tv_doll {
    position: absolute;
    width: fluid(490px);
    height: fluid(349px);
    background-image: url('~@/assets/img/tv_doll.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 0 auto;
    animation-delay: 12.5s;
    animation-duration: 2.5s;
    animation-name: tv_doll;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    z-index: 4;
    opacity: 0;
    animation-play-state: paused;

  }

  @keyframes tv_doll {
    0% {
      opacity: 0;
    }

    0.1% {
      opacity: 1;
    }

    99.5% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  #tv_people2 {
    position: absolute;
    width: fluid(490px);
    height: fluid(349px);
    background-image: url('~@/assets/img/tv_people.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 0 auto;
    animation-delay: 13.85s;
    animation-duration: 8.5s;
    animation-name: tv_people2;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    // z-index: 1;
    animation-play-state: paused;

  }

  @keyframes tv_people2 {
    0% {
      opacity: 1;
    }

    99.9% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  #tv_number {
    position: absolute;
    bottom: fluid(105px);
    z-index: 10;
    animation-delay: 0s;
    animation-duration: 20s;
    animation-name: tv_number;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-play-state: paused;


    p {
      color: white;
      font-size: fluid(18px);
      font-weight: 700;
      background: #000;
      padding: fluid(3px) fluid(15px);
      border: fluid(5px) solid #fff;

    }
  }

  @keyframes tv_number {
    0% {
      opacity: 0;
    }

    85.9% {
      opacity: 0;
    }

    86% {
      opacity: 1;
    }

    100% {
      opacity: 1;
    }
  }

  #off {
    position: absolute;
    right: fluid(195px);
    bottom: fluid(70px);
    width: fluid(23px);
    height: fluid(23px);
    background-image: url('~@/assets/img/button_off.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    z-index: 5;
    animation-duration: 11.75s;
    animation-name: switch_off;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-play-state: paused;

  }

  @keyframes switch_off {
    0% {
      opacity: 1;
    }

    99.9% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  #on {
    position: absolute;
    right: fluid(195px);
    bottom: fluid(70px);
    width: fluid(23px);
    height: fluid(23px);
    background-image: url('~@/assets/img/button_on.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    z-index: 13;
    animation-duration: 11.75s;
    animation-name: switch_on;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-play-state: paused;

  }

  @keyframes switch_on {
    0% {
      opacity: 0;
    }

    99.9% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
</style>